import { ListingFilter } from "../../../filters/ListingFilter";
import { PagedResponse } from "../../../types/PagedResponse";
import { Listing } from "../../../types/Listing";
import { Client } from "../Client";
import { APIRequest, APIRequestMethod, CacheMode } from "../APIRequest";
import { OpenHomes } from "../../../types/OpenHomes";
import { VCalContent } from "../../../types/VCalContent";
import { OpenHomeICS } from "../../../types/OpenHomeICS";
import { BulkRequest, BulkResponse, CountListingsRequest, InspectRealEstateListingModel, OneFormListingModel, SearchListingsRequest } from "../../../types";

class ListingsAPI {
    Search(filter: ListingFilter): Promise<PagedResponse<Listing>> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, "/api/listings/search", filter));
    }

    GetOpenHomes(filter: ListingFilter): Promise<OpenHomes> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, "/api/openhomes", filter));
    }

    Get(listingId: string): Promise<Listing> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/listings/${listingId}`).SetCacheMode(CacheMode.NoCache));
    }

    GetOpenHomeICS(listingId: string, startDate: Date, endDate: Date) : Promise<VCalContent> {
        return Client.Request(new APIRequest(APIRequestMethod.POST, `/api/listings/${listingId}/open_homes/ics`, new OpenHomeICS(startDate, endDate)));
    }

    GetSuburbs(filter: ListingFilter): Promise<string[]> {
        return Client.Request<string[]>(new APIRequest(APIRequestMethod.POST, "/api/listings/suburbs", filter));
    }

    GetInspectRealEstateData(listingId: string): Promise<InspectRealEstateListingModel> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/listings/${listingId}/integrations/inspectrealestate`));
    }

    GetOneFormData(listingId: string): Promise<OneFormListingModel> {
        return Client.Request(new APIRequest(APIRequestMethod.GET, `/api/listings/${listingId}/integrations/oneform`));
    }

    async Bulk(requests: (CountListingsRequest | SearchListingsRequest)[]): Promise<void> {
        const request: BulkRequest = { Entries: [] };

        for(let i = 0; i < requests.length; i++) {
            const req = requests[i];
            req.Id = i;

            request.Entries.push(req);
        }

        var res = await Client.Request<BulkResponse>(new APIRequest(APIRequestMethod.POST, '/api/listings/bulk', request));

        res.Entries.forEach((entry, idx) => {
            if (entry.Success) {
                requests[idx].Callback(entry.Response);
            }
        });
    }
}

export { ListingsAPI }